import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const PhoneIcon = ({ references }) => (
  <SvgIcon
    references={references ? 1 : 0}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <StyledPath
      d="M9.678 10.5735C9.87492 10.3765 10.0804 10.1882 10.2773 9.99125C10.4743 9.80288 10.6112 9.66589 10.791 9.70014C10.851 9.7087 10.9023 9.72583 10.9537 9.76864C11.0136 9.81145 11.0736 9.89707 11.1335 9.97412C11.2191 10.0854 11.3048 10.1967 11.3989 10.308C11.7928 10.8132 12.1781 11.3098 12.5719 11.8149C12.6575 11.9177 12.7431 12.029 12.8202 12.1403C12.8716 12.2088 12.9315 12.2773 12.9572 12.3372C12.9914 12.4143 13 12.4828 13 12.5598C13 12.7567 12.8716 12.8852 12.6747 13.065C12.4692 13.2619 12.2722 13.4588 12.0668 13.6557C11.2705 12.6283 10.4743 11.6009 9.66943 10.5735M3.55625 2.70509C3.76174 2.50816 3.96722 2.31124 4.17271 2.11432C4.36107 1.92596 4.4895 1.79753 4.66074 1.82321C4.72923 1.83178 4.78916 1.85746 4.85766 1.90883C4.90903 1.95164 4.9604 2.0287 5.01177 2.09719C5.10595 2.21706 5.20013 2.33693 5.28575 2.44823C5.68816 2.96194 6.09057 3.47566 6.48442 3.99793C6.57003 4.10924 6.65565 4.22054 6.74127 4.33184C6.78408 4.39178 6.84401 4.45171 6.8697 4.51164C6.91251 4.59726 6.92963 4.68288 6.92963 4.75994C6.92963 4.95686 6.8012 5.07673 6.61284 5.25653C6.40736 5.45345 6.20187 5.65037 5.99639 5.8473C5.18301 4.79419 4.36107 3.74964 3.54769 2.69653M3.33364 2.90201C4.15558 3.95512 4.96896 4.99967 5.78234 6.05278C5.39706 6.41238 5.67104 6.93465 5.88508 7.34562C5.9707 7.51686 6.09913 7.67954 6.19331 7.85934C6.23612 7.91927 6.27893 7.98777 6.32174 8.0477C6.39023 8.14188 6.45873 8.24462 6.52722 8.3388C6.60428 8.44155 6.68134 8.55285 6.76696 8.66415C6.79264 8.6984 6.82689 8.73265 6.85258 8.7669C6.91251 8.83539 6.96388 8.91245 7.02381 8.98951C7.04094 9.01519 7.06662 9.04088 7.08375 9.06656C7.16937 9.16074 7.24642 9.25492 7.32348 9.3491C7.40054 9.43472 7.47759 9.52034 7.55465 9.61452C7.61458 9.67446 7.66595 9.74295 7.72589 9.80288C7.91425 9.97412 8.07692 10.1796 8.25672 10.3423C8.62488 10.6591 9.06154 11.1557 9.46395 10.7618C10.2602 11.7807 11.0565 12.8081 11.8527 13.8355C11.7671 13.9211 11.6815 13.964 11.5959 14.0068C11.4332 14.0838 11.2705 14.1266 11.0993 14.1523C10.5941 14.2465 10.0718 14.1523 9.58382 13.9982C9.44683 13.9554 9.3184 13.8955 9.18141 13.8441C9.0701 13.8013 8.96736 13.7499 8.85606 13.69C8.61632 13.5615 8.38515 13.4246 8.14542 13.2619C7.92281 13.1078 7.7002 12.9365 7.46903 12.7567C7.27211 12.6026 7.09231 12.4228 6.90395 12.2516C6.83545 12.1831 6.76696 12.1146 6.69846 12.0461C6.59572 11.9348 6.48442 11.8235 6.38167 11.7122C6.27037 11.5838 6.1505 11.4553 6.0392 11.3269C6.00495 11.2841 5.97926 11.2498 5.94502 11.207C5.84227 11.0872 5.73953 10.9587 5.63679 10.8389C5.6111 10.8046 5.58542 10.7704 5.55973 10.7361C5.46555 10.6077 5.36281 10.4793 5.26863 10.3594C5.24294 10.3252 5.21726 10.2909 5.19157 10.2567C5.08883 10.1111 4.97752 9.96556 4.87478 9.82001C4.78916 9.69158 4.69498 9.55459 4.6008 9.42616C4.54943 9.34054 4.4895 9.26349 4.43813 9.17787C4.3097 8.93813 4.14702 8.72409 4.02716 8.48436C3.99291 8.4073 3.9501 8.3388 3.90729 8.27031C3.79599 8.03914 3.66756 7.80797 3.56481 7.58536C3.43639 7.29425 3.30796 7.01171 3.22234 6.72061C3.08535 6.30108 2.97405 5.89867 2.91411 5.4877C2.81993 4.84556 2.81993 4.21198 3.00829 3.58696C3.05966 3.41572 3.12816 3.25305 3.22234 3.08181C3.25659 3.02188 3.29083 2.95338 3.34221 2.90201"
      fill="#A7905D"
    />
  </SvgIcon>
);

PhoneIcon.propTypes = {
  references: PropTypes.bool,
};

const StyledPath = styled.path`
  fill: ${({ theme: { rigaColor } }) => rigaColor('#929292')};
`;

const SvgIcon = styled.svg`
  stroke: none;
  ${({ theme: { convertPx, isRTL }, references }) => css`
    width: ${convertPx(24)};
    height: ${convertPx(24)};
    ${references &&
    css`
      width: ${convertPx(12)};
      height: ${convertPx(15)};
      margin-right: ${convertPx(isRTL ? 0 : 8)};
      margin-left: ${convertPx(isRTL ? 8 : 0)};
      path {
        fill: #333e50;
      }
    `}
  `}
`;

PhoneIcon.propTypes = {
  color: PropTypes.string,
};

export default PhoneIcon;
